import Vue from 'vue';

let handleOutsideClick;

export const clickOutside = {
    bind (el, binding, vnode) {
        handleOutsideClick = (e) => {
            e.stopPropagation();
            if (!document.body.contains(el)) {
                return;
            }
            const { handler, exclude } = binding.value

            let clickedOnExcludedEl = false
            if (exclude) {
                exclude.forEach(refName => {
                    if (!clickedOnExcludedEl) {
                        const excludedEl =
                            Array.isArray(vnode.context.$refs[refName]) ?
                            vnode.context.$refs[refName][0] :
                            vnode.context.$refs[refName];
                        if (excludedEl) {
                            clickedOnExcludedEl = excludedEl.contains(e.target);
                        }                        
                    }
                });
            }
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                vnode.context[handler]();
            }
        }
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
    },

    unbind () {
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
    }
}

Vue.directive('click-outside', clickOutside);